import { render, staticRenderFns } from "./AlterPlan.vue?vue&type=template&id=0b18f518&scoped=true&"
import script from "./AlterPlan.vue?vue&type=script&lang=js&"
export * from "./AlterPlan.vue?vue&type=script&lang=js&"
import style0 from "./AlterPlan.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AlterPlan.vue?vue&type=style&index=1&id=0b18f518&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b18f518",
  null
  
)

export default component.exports